/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 *
 * @author Alexander Golshtein
 * @version 1.23.2
 * @since 1.23.2
 */

import { IProductOfferingRecurringCharge } from '@pages/PageProducts/tariffsAndServicesTypes';

const getItemWithMaxPrice = (itemsArray: IProductOfferingRecurringCharge[]) => {
    return itemsArray.reduce((acc, cur) => cur.price > acc.price ? cur : acc, itemsArray[0])
}

export const getRecurringChargeItem =
    (itemsArray:  IProductOfferingRecurringCharge[]):IProductOfferingRecurringCharge | null => {
    let recurringChargeItem: IProductOfferingRecurringCharge | null  = null;
    if (itemsArray?.length === 1) {
        recurringChargeItem = itemsArray[0];
    }
    if (itemsArray?.length > 1) {
        const filteredByPriority = itemsArray.filter(item=>!!item?.priority || item?.priority === 0);
        const allItemsHavePriority = filteredByPriority.length === itemsArray.length;

        if (allItemsHavePriority) {
            const minPriority = itemsArray.reduce((acc, cur) =>
                cur?.priority && cur?.priority < acc ? cur.priority : acc, itemsArray[0].priority as number);
            const itemsWithMinPriority = itemsArray.filter(item => item.priority === minPriority);
            return getItemWithMaxPrice(itemsWithMinPriority);
        }

        const filteredByOccurrence = itemsArray.filter(item=>!!item.occurrence || item.occurrence === 0);
        const allItemsHaveOccurrence = filteredByOccurrence.length === itemsArray.length;

        if (allItemsHaveOccurrence) {
            const minOccurrence = itemsArray.reduce((acc, cur) =>
                cur.occurrence < acc ? cur.occurrence : acc, itemsArray[0].occurrence);
            const itemsWithMinOccurrence = itemsArray.filter(item => item.occurrence === minOccurrence);
            return getItemWithMaxPrice(itemsWithMinOccurrence);
        }

        return getItemWithMaxPrice(itemsArray);
    }
    return recurringChargeItem
}
